import NamedDto from 'modules/base/dto/NamedDto';
import OptimizerLogFieldEditDto from './OptimizerLogFieldEditDto';

export class OptimizerLogEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.tableName = null;
		/** @type {string} */
		this.description = null;
		/** @type {OptimizerLogFieldEditDto[]} */
		this.fields = null;
		/** @type {number} */
		this.userGroup = null;
	}

	/**
	 * @typedef {Object} _OptimizerLogEditDtoProps
	 * @property {string} tableName
	 * @property {string} description
	 * @property {OptimizerLogFieldEditDto[]} fields
	 * @property {number} userGroup
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _OptimizerLogEditDtoProps} OptimizerLogEditDtoProps
	 */
	/**
	 *
	 * @param {OptimizerLogEditDtoProps} props
	 * @returns {OptimizerLogEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.tableName = props.tableName;
		this.description = props.description;
		this.fields = props.fields !== null ? props.fields.map(d => new OptimizerLogFieldEditDto().setup(d)) : [];
		this.userGroup = props.userGroup;
		return this;
	}
}

export default OptimizerLogEditDto;
